import { getService } from '../../utils';

export const getSafetySettingsService = getService('safetySettings');
